import { Component, OnInit } from '@angular/core';
import { PitchinNewsService } from '../../../core/services/api/pitchin-news.service';
import { NewsBlog } from '../../../core/models/news/pitchin-news-blog';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-dashboard-news',
    templateUrl: './dashboard-news.component.html',
    standalone: false
})
export class DashboardNewsComponent implements OnInit {
  constructor(private readonly pitchinNewsService: PitchinNewsService) {}
  newsBlogs: NewsBlog[] = [];
  isError = false;
  isLoading = false;
  newsUrl = 'https://news.pitchin.my/';

  ngOnInit(): void {
    this.getNews();
  }

  getNews() {
    this.isError = false;
    this.isLoading = true;
    this.pitchinNewsService
      .getBlogs()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe({
        next: (response) => {
          this.newsBlogs = response.data;
        },
        error: (err) => {
          this.isError = true;
          console.error(err);
        },
      });
  }

  getFullImageURL(imageSRC: string) {
    let wixLocalURL = '';
    const wixImageURL = 'https://static.wixstatic.com/media/';

    if (imageSRC.startsWith('image:')) {
      wixLocalURL = imageSRC.replace('image://v1/', '');
      wixLocalURL = wixLocalURL.substring(0, wixLocalURL.indexOf('/'));
      return wixImageURL + wixLocalURL;
    }

    if (imageSRC.startsWith('wix:image:')) {
      wixLocalURL = imageSRC.replace('wix:image://v1/', '');
      wixLocalURL = wixLocalURL.substring(0, wixLocalURL.lastIndexOf('/'));
      return wixImageURL + wixLocalURL;
    }
    return imageSRC;
  }

  getUrl(slug: string) {
    return this.newsUrl + 'post/' + slug;
  }
}
